import { render, staticRenderFns } from "./Triggers.vue?vue&type=template&id=e52c8d90"
import script from "./Triggers.vue?vue&type=script&lang=js"
export * from "./Triggers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports